<template>
  
  <div v-if="div" class="error" style="width: 100%;
    margin-top: 0.25rem;
    font-size: 0.875em;
    color: #dc3545;">
    {{ message }}
    <slot></slot>
  </div>
  <b-form-invalid-feedback v-else>
    {{ message }}
    <slot></slot>
  </b-form-invalid-feedback>
</template>

<script>
export default {
    name: "FormInvalidFeedback",
    props: {
        type: String,
        length: Number,
        div: {type: Boolean, default: false}
    },
    data(){
        return {
            message: ""
        }
    },
    mounted(){
        switch(this.type){
            case 'required': 
                this.message = this.$t("errors.required")
            break;
            case 'email': 
                this.message = "Invalid Email."
            break;
            case 'minlength':
                this.message = `Minimum length should be ${length}`
            break;
            case 'maxlength':
                this.message = `Maximum length should be ${length}`
            break;
            case 'exact':
                this.message = `Length should be ${length}`
            break;
            default: 
        }
    }
}
</script>